import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { Nbs, NbsModel } from "../../../domain/models/nbs";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteNbs implements Nbs {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  async loadByLc116(id: number): Promise<NbsModel[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/lc116/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.badRequest:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
